/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSalesforceSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      function DesignerSalesforceSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.connection = new DesignerConnection();
        this.object_name = null;
        this.where_clause = null;
        this.source_action = null;
        this.is_chunk_size_enabled = false;
      }

      DesignerSalesforceSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerSalesforceSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          connection: this.connection.getData(),
          cloud_storage_connection_id: String(this.connection.id || ''),
          object_name: this.object_name || this.defaults.object_name,
          where_clause: this.where_clause || this.defaults.where_clause,
          source_action: this.source_action || this.defaults.source_action,
          access_mode: this.access_mode || this.defaults.access_mode,
          query: this.query || this.defaults.query,
          chunk_size: this.is_chunk_size_enabled ? this.chunk_size || this.defaults.chunk_size : null,
          is_chunk_size_enabled: this.is_chunk_size_enabled,
        });

        return data;
      };

      DesignerSalesforceSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerSalesforceSourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.connection.setData(data.connection);
        this.object_name = data.object_name;
        this.where_clause = data.where_clause;
        this.source_action = data.source_action;
        this.access_mode = data.access_mode;
        this.query = data.query;
        this.chunk_size = data.is_chunk_size_enabled ? data.chunk_size : null;
        this.is_chunk_size_enabled = data.is_chunk_size_enabled;
        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerSalesforceSourceComponent;
    },
  ]);
})(window.angular);
